import { createSlice } from '@reduxjs/toolkit';
import { showToast } from '@global/design-system/molecules';
import createFetchReducer from '@app/utils/createFetchReducer';

import { GenericEntityState, ResponseAction } from '@app/redux/types';
import { exportInquiriesTypes, getInquiriesTypes, LeadType } from './types';
import { FIRST_PAGE } from '../constants';
import fileDownload from 'js-file-download';

import { ToastMessage } from '@app/constants';

export const initialState: GenericEntityState = {
	loading: false,
	error: {},
	response: {
		status: null,
		message: null,
	},
	pagination: {
		totalPages: null,
		currentPage: null,
		count: null,
		pages: {},
	},
	inquiriesCount: 0,
	inquiries: [],
	inquiriesSelected: [],
	custom: {
		getInquiriesLoading: false,
		exportInquiriesLoading: false,
		exportInquiriesResponse: null,
	},
};

export type inquiriesType = typeof initialState;

const getInquiriesMapper = (state: inquiriesType, action: ResponseAction) => {
	const isSinglePage = action.payload?.singlePage || false;
	const page = action.response?.page || FIRST_PAGE;

	if (isSinglePage) {
		// For single page mode, always replace the inquiries
		state.inquiries = action.response.leads;
	} else if (page === FIRST_PAGE) {
		state.inquiries = action.response.leads;
	} else {
		state.inquiries = [...state.inquiries, ...action.response.leads];
	}

	state.inquiriesCount = state.inquiries.length || 0;
	state.pagination = {
		totalPages: action.response.totalPages,
		currentPage: page,
		count: action.response.count,
		pages: {},
	};
};

export const exportInquiriesSuccessMapper = (
	_state: inquiriesType,
	action: ResponseAction,
) => {
	const { response } = action;
	fileDownload(response, 'inquiries.csv');
	return showToast({
		message: ToastMessage.exportInquiriesSuccess,
		type: 'success',
	});
};

function exportInquiriesErrorMapper(
	_state: inquiriesType,
	_action: ResponseAction,
) {
	return showToast({
		message: ToastMessage.exportInquiriesError,
		type: 'error',
	});
}

const inquirySlice = createSlice({
	name: 'inquiry',
	initialState,
	reducers: {
		SELECT_INQUIRIES(state: inquiriesType, action: ResponseAction) {
			state.inquiriesSelected = action.payload as LeadType[];
		},
	},
	extraReducers: {
		...createFetchReducer(getInquiriesTypes, getInquiriesMapper),
		...createFetchReducer(
			exportInquiriesTypes,
			exportInquiriesSuccessMapper,
			exportInquiriesErrorMapper,
		),
	},
});

export default inquirySlice.reducer;
